import type { SvgIconProps } from "@mui/material";

import baselineSvg from "./max-icon.baseline.svg?react";
import textSvg from "./max-icon.text.svg?react";
import { makeSvgIcon } from "./svg-icon";

const MaxIconBaseline = makeSvgIcon(baselineSvg);
const MaxIconText = makeSvgIcon(textSvg);

export function MaxIcon({
  text = true,
  ...props
}: SvgIconProps & { text?: boolean }) {
  return text ? <MaxIconText {...props} /> : <MaxIconBaseline {...props} />;
}

export default MaxIcon;
